import { api } from './api';

export interface Employee {
  id: string; userId: string | null; employeeCode: string; fullName: string;
  email: string | null; mobile: string | null;
  departmentId: string | null; designationId: string | null;
  employmentType: string; status: string; joiningDate: string; exitDate: string | null;
  qualifications: string | null;
}
export interface Named { id: string; name: string; isActive: boolean; }
export interface LeaveType { id: string; name: string; code: string | null; annualQuota: number; carryForward: boolean; maxCarryForward: number; isActive: boolean; isPaid: boolean; }
export interface LeaveBalance { leaveTypeId: string; year: number; entitled: number; used: number; available: number; }
export interface LeaveRequest {
  id: string; employeeId: string; leaveTypeId: string; fromDate: string; toDate: string;
  days: number; reason: string | null; status: string; reviewNote: string | null; submittedAt: string;
}
export interface Holiday { id: string; date: string; name: string; }

export const hrApi = {
  // employees (tenant-admin)
  listEmployees: (departmentId?: string) => api.get<Employee[]>(`/api/hr/employees${departmentId ? `?departmentId=${departmentId}` : ''}`),
  createEmployee: (b: Record<string, unknown>) => api.post<Employee>('/api/hr/employees', b),
  updateEmployee: (id: string, b: Record<string, unknown>) => api.put<Employee>(`/api/hr/employees/${id}`, b),
  linkUser: (id: string, userId: string | null) => api.post<Employee>(`/api/hr/employees/${id}/link-user`, { userId }),
  exitEmployee: (id: string, status: string, exitDate: string) => api.post<Employee>(`/api/hr/employees/${id}/exit`, { status, exitDate }),

  // config
  listDepartments: () => api.get<Named[]>('/api/hr/departments'),
  createDepartment: (name: string, code?: string) => api.post<Named>('/api/hr/departments', { name, code: code ?? null }),
  listDesignations: () => api.get<Named[]>('/api/hr/designations'),
  createDesignation: (name: string) => api.post<Named>('/api/hr/designations', { name, code: null }),
  listLeaveTypes: () => api.get<LeaveType[]>('/api/hr/leave-types'),
  createLeaveType: (b: { name: string; code?: string | null; annualQuota: number; carryForward: boolean; maxCarryForward: number; isPaid: boolean }) =>
    api.post<LeaveType>('/api/hr/leave-types', b),
  listHolidays: (year?: number) => api.get<Holiday[]>(`/api/hr/holidays${year ? `?year=${year}` : ''}`),
  createHoliday: (date: string, name: string) => api.post<Holiday>('/api/hr/holidays', { date, name }),

  // leave (admin)
  pendingLeave: () => api.get<LeaveRequest[]>('/api/hr/leave/pending'),
  reviewLeave: (id: string, approve: boolean, note?: string) =>
    api.post<LeaveRequest>(`/api/hr/leave/${id}/review`, { approve, note: note ?? null }),
  employeeBalances: (id: string, year?: number) => api.get<LeaveBalance[]>(`/api/hr/employees/${id}/balances${year ? `?year=${year}` : ''}`),

  // my leave (any staff)
  myEmployee: () => api.get<Employee>('/api/hr/me/employee'),
  myBalances: (year?: number) => api.get<LeaveBalance[]>(`/api/hr/me/balances${year ? `?year=${year}` : ''}`),
  myLeave: () => api.get<LeaveRequest[]>('/api/hr/me/leave'),
  applyLeave: (b: { leaveTypeId: string; fromDate: string; toDate: string; reason?: string | null }) =>
    api.post<LeaveRequest>('/api/hr/me/leave', b),
  cancelLeave: (id: string, note?: string) => api.post<LeaveRequest>(`/api/hr/me/leave/${id}/cancel`, { note: note ?? null }),
};
